import { __ } from '@wordpress/i18n'
import { Component } from '@wordpress/element';
import {
	GradientPicker,
	__experimentalGradientPicker,
} from '@wordpress/components';

import './editor.scss';

const GRADIENTS = wp.data.select( 'core/block-editor' ).getSettings().gradients;

export default class EedeeGradientPicker extends Component {
	constructor() {
		super( ...arguments );
		this.setBackgroundGradient = this.setBackgroundGradient.bind( this );

		this.state = {
			gradient: this.props.value,
		};

		if ( typeof GradientPicker === 'function' ) {
			this.GradientPicker = GradientPicker;
		} else {
			this.GradientPicker = __experimentalGradientPicker;
		}
	}

	setBackgroundGradient( gradient ) {
		const { onChange } = this.props;
		const newGradient = gradient;
		this.setState( {
			tmpGradient: newGradient,
		} );
		onChange( newGradient );
	}

	render() {
		return (
			<div className="blocks-size__main">
				<p>{ __( 'Gradient Presets' ) }</p>
				<this.GradientPicker
					gradients={ GRADIENTS }
					value={ this.state.tmpGradient }
					onChange={ gradient => {
						this.setBackgroundGradient( gradient );
					} }
				/>
			</div>
		);
	}
}
